module.exports = __webpack_public_path__ + "static/media/device-quiz@3x.8ab4f5bc.png";